import React from 'react';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import markSrc from '../assets/veerny-mark-white.svg';
import wordmarkSrc from '../assets/veerny-wordmark-white.svg';
import { KINDERGARTENS } from '../common/constants/routes.constants';
import { SIDEBAR_FOCUS_SX } from './SidebarFinanceGroup';

import { palette } from '../theme';
/**
 * The Veerny mark (and, at full width, the word) linking home.
 *
 * Images rather than inline SVG: both white files carry the same clipPath id, and two inline
 * copies on one page would be duplicate ids. White on #3f3273 is 10.97:1; the #786cb2
 * mark is never used on the sidebar (2.39:1).
 */
const SidebarLogo: React.FC<{ collapsed?: boolean }> = ({ collapsed = false }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <Box
      component="a"
      href={KINDERGARTENS}
      aria-label={t('nav.home')}
      onClick={(event: React.MouseEvent) => {
        // a real link, so it can be opened in a new tab; a plain click stays in the app
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
        event.preventDefault();
        navigate(KINDERGARTENS);
      }}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: collapsed ? 'center' : 'flex-start',
        gap: '10px',
        height: 40,
        width: collapsed ? 48 : 'auto',
        pl: collapsed ? 0 : '8px',
        borderRadius: '8px',
        flex: 'none',
        '&:focus-visible': { outline: `2px solid ${palette.common.white}`, outlineOffset: '-2px' },
        ...SIDEBAR_FOCUS_SX
      }}
    >
      <img src={markSrc} alt="" width={27} height={32} />
      {!collapsed && <img src={wordmarkSrc} alt="" width={65} height={22} />}
    </Box>
  );
};

export default SidebarLogo;
